// src/components/MonthlyMaintenanceCost.jsx
import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const MonthlyMaintenanceCost = ({ data = [] }) => {
  const ref = useRef();

  useEffect(() => {
    d3.select(ref.current).selectAll("*").remove(); // clear previous chart

    // const width = 600;
    // const height = 300;
    const margin = { top: 30, right: 20, bottom: 40, left: 50 };
    const width = data.length * 95;
    const height = 300 - margin.top - margin.bottom; // reduced total height


    const svg = d3
      .select(ref.current)
      .append("svg")
      .attr("width", width)
      .attr("height", height);

    const chart = svg
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const x = d3
      .scaleBand()
      .domain(data.map((d) => d.month))
      .range([0, width - margin.left - margin.right])
      .padding(0.2);

    const y = d3
      .scaleLinear()
      .domain([0, d3.max(data, (d) => d.cost) + 500])
      .range([height - margin.top - margin.bottom, 0])
      .nice();

    // X Axis
    chart
      .append("g")
      .attr("transform", `translate(0,${height - margin.top - margin.bottom})`)
      //.call(d3.axisBottom(x));
      .call(d3.axisBottom(x).tickFormat(d => d.replace('-', '’')));

    // Y Axis
    chart.append("g").call(d3.axisLeft(y).ticks(5).tickFormat(d => `$${d}`));

    // Dotted grid lines
    chart
      .append("g")
      .selectAll("line.grid")
      .data(y.ticks(5))
      .enter()
      .append("line")
      .attr("x1", 0)
      .attr("x2", width - margin.left - margin.right)
      .attr("y1", d => y(d))
      .attr("y2", d => y(d))
      .attr("stroke", "#d1d5db")
      .attr("stroke-dasharray", "3,3");

    // Bars
    chart
      .selectAll("rect")
      .data(data)
      .enter()
      .append("rect")
      .attr("x", (d) => x(d.month))
      .attr("y", (d) => y(d.cost))
      .attr("width", x.bandwidth())
      .attr("height", (d) => height - margin.top - margin.bottom - y(d.cost))
      .attr("fill", "#2563eb"); // Tailwind blue-600

    // Labels above bars
    chart
      .selectAll("text.label")
      .data(data)
      .enter()
      .append("text")
      .attr("x", (d) => x(d.month) + x.bandwidth() / 2)
      .attr("y", (d) => y(d.cost) - 6)
      .attr("text-anchor", "middle")
      .attr("font-size", "12px")
      .attr("fill", "#374151")
      .text((d) => d.cost.toLocaleString());
  }, [data]);

  return (
    <div className="rounded border border-gray-300 bg-white overflow-auto p-4 mt-2">
      <h3 className="text-sm font-semibold text-gray-700 mb-2 v_health_blocks_heading">Monthly Maintenance Cost (Last {data.length} Months)</h3>
      <div ref={ref}></div>
    </div>
  );
};

export default MonthlyMaintenanceCost;
